import { render, staticRenderFns } from "./OnlineReservationScheduleSettingTable.vue?vue&type=template&id=10015c34&scoped=true&lang=pug"
import script from "./OnlineReservationScheduleSettingTable.vue?vue&type=script&lang=ts"
export * from "./OnlineReservationScheduleSettingTable.vue?vue&type=script&lang=ts"
import style0 from "./OnlineReservationScheduleSettingTable.vue?vue&type=style&index=0&id=10015c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10015c34",
  null
  
)

export default component.exports